export default function ComparisonChecklist() {
  const checklistItems = [
    {
      category: 'Licensing & Insurance',
      items: [
        'Valid Texas contractor license',
        'Current general liability insurance',
        'Workers\' compensation coverage',
        'Bonded and insured documentation',
        'Professional certifications'
      ]
    },
    {
      category: 'Experience & Expertise',
      items: [
        'Years in business (minimum 5+ years)',
        'Portfolio of completed projects',
        'Specialization in your door type',
        'References from recent clients',
        'Knowledge of safety standards'
      ]
    },
    {
      category: 'Pricing & Estimates',
      items: [
        'Detailed written estimate',
        'Transparent pricing breakdown',
        'Parts costs clearly listed',
        'Labor costs specified',
        'No hidden fees or charges'
      ]
    },
    {
      category: 'Quality & Warranty',
      items: [
        'Parts and labor warranty offered',
        'Quality of materials used',
        'Brand name products available',
        'Safety feature compliance',
        'Post-installation support'
      ]
    },
    {
      category: 'Service & Availability',
      items: [
        'Emergency service available',
        'Same-day repair options',
        'Clear project timeline',
        'Regular maintenance plans',
        'Flexible scheduling'
      ]
    },
    {
      category: 'Reviews & Reputation',
      items: [
        'Positive online reviews (4+ stars)',
        'BBB accreditation and rating',
        'Local community reputation',
        'Repeat customer rate',
        'Industry awards or recognition'
      ]
    }
  ];

  return (
    <section id="checklist" className="py-20 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Contractor Comparison Checklist
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Use this comprehensive checklist to evaluate and compare garage door contractors. Make an informed decision by checking off these essential criteria.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {checklistItems.map((section, index) => (
            <div key={index} className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-teal-500 transition-all">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900">{section.category}</h3>
              </div>
              <ul className="space-y-2">
                {section.items.map((item, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                    <span className="text-sm text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-3">
            Need Help Choosing a Contractor?
          </h3>
          <p className="text-white/90 mb-6 max-w-2xl mx-auto">
            Our team can help you find the right garage door contractor for your project. Get personalized recommendations based on your specific needs.
          </p>
          <a href="#directory" className="inline-block px-8 py-3 bg-white text-gray-900 font-semibold rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap">
            Get Matched with Contractors
          </a>
        </div>
      </div>
    </section>
  );
}
